module.exports = __webpack_public_path__ + "static/media/jogo-da-cobrinha.0f4d8839.png";